/* Text returned from Stencil components after DOM is rendered. */
export const STENCIL = {
  MESSAGE_BANNER_SUCCESS: "Success!",
  MESSAGE_BANNER_ERROR: "Error",
  MESSAGE_BANNER_INFO: "Information"
}

/* Mock IDs for UI component for testing. */
export const MOCK_ID = {
  HEADER: {
    USERMENU: "Mock-UserMenu",
    SUBHEADER: "Mock-SubHeader",
    NOTIFICATIONS: "Mock-Notifications",
  },
  NAVIGATION: "Mock-Navigation",
  HELPFUL_INFORMATION: "HelpfulInformation",
  ARTICLE_WITH_VIDEO: "Article_With_Video",
  ARTICLE_WITHOUT_VIDEO: "Article_Without_Video",
  FAQ_CONTAINER: "faqContainer",
  FAQ_ANSWER_EXPAND_ALL: "faqAnswerExpandAll",
  DOWNLOAD_CARD_CONTENT: "downloadCardContent",
  TILE_AREA_TITLE: "TilesArea_title",
  VEST_TILE_L: "VestTile_l",
  MESSAGE: "Message-MessageBanner",
  CHANGE_LANGUAGE: {
    MODAL: "ChangeLanguage-Modal",
    CONFIRM: "ChangeLanguage-Confirm"
  }
}
